import { ImportRepositoryResponse } from '../../../typings/api';
import { ServiceVCS } from '../../components/projects/import/types';
import { IAsyncStatus, Repository, ServiceFilter, ServiceQueryParameters } from '../../types';

export const VCS_FETCH_REPOSITORIES = 'VCS_FETCH_REPOSITORIES';
export const VCS_FETCH_INSTANCES = 'VCS_FETCH_INSTANCES';
export const VCS_FETCH_FILTERS = 'VCS_FETCH_FILTERS';

export const VCS_SET_QUERY_PARAMETERS = 'VCS_SET_QUERY_PARAMETERS';
export const VCS_RESET_IMPORT_STATUS = 'VCS_RESET_IMPORT_STATUS';
export const VCS_SET_INSTANCE = 'VCS_SET_INSTANCE';
export const VCS_SET_FILTER = 'VCS_SET_FILTER';
export const VCS_SET_BRANCH_ON_REPOSITORY = 'VCS_SET_BRANCH_ON_REPOSITORY';
export const VCS_SELECT_REPOSITORY = 'VCS_SELECT_REPOSITORY';

export const VCS_DISCONNECT_SERVICE = 'VCS_DISCONNECT_SERVICE';
export const VCS_IMPORT_REPOSITORIES = 'VCS_IMPORT_REPOSITORIES';
export const VCS_IMPORT_REPOSITORIES_INCREMENT_GROUP_COUNT = 'VCS_IMPORT_REPOSITORIES_INCREMENT_GROUP_COUNT';

export type VCSInstanceState = {
  connected: boolean;
  privateAccess: boolean; // has the user been granted "private" access (github specific)
  filters: ServiceFilter[];
  repositories: Repository[];
  selectedRepositories: Repository[]; // list of indexes from repositories
};

export type VCSImportState = {
  loading: boolean;
  isBulkImport: boolean;
  importGroupCount: number;
  importGroupsCompleted: number;
  totalRepoCount: number;
  successfullyImportedRepoGroups: ImportRepositoryResponse[];
};

export type VCSState = {
  status: IAsyncStatus<Error | null>;
  importStatus: VCSImportState;
  query: ServiceQueryParameters;
  instances: string[];
  instanceData: {
    [instance: string]: VCSInstanceState;
  };
};

// async action type inside the reducer fn
export type VCSReducerAsyncActionData<T> = {
  meta: {
    service: ServiceVCS;
    [key: string]: any;
  };
  payload: Response & {
    data: T;
  };
  type: string;
};

// non async payload
export type VCSReducerNonAsyncActionData<T> = {
  meta?: {
    service: ServiceVCS;
  };
  payload: T;
  type: string;
};

// chunk import requests into size of 25
export const IMPORT_CHUNK_SIZE = 25;

// 3 or more projects imported at the same time will be done in the agent
export const BULK_IMPORT_MAX = 2;
